import React, { useEffect, useState, useRef } from "react";
import Banner from "../Components/Banner";

const HouseAndLandPackages = () => {
    const [iframeHeight, setIframeHeight] = useState('100vh');
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'sensoreal-height' && event.data.source === 'packages') {
                setIframeHeight(event.data.height + 'px');
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    return (
        <>
            {/* Banner */}
            <Banner
                title={"House and land packages"}
                bgImage="bg-packages-banner"
            />

            {/* Sensoreal Webfeed */}
            <div className="packages-container" style={{
                width: '100%',
                margin: '0 auto',
            }}>
                <iframe
                    ref={iframeRef}
                    src="/sensoreal-packages.html"
                    width="100%"
                    frameBorder="0"
                    style={{ border: 0, height: iframeHeight, minHeight: '100vh' }}
                    title="Banyan Hill House and Land Packages"
                    sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                    scrolling="no"
                />
            </div>
        </>
    );
};

export default HouseAndLandPackages;
